/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Orientation/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ChoiceToggle from 'DesignSystem/ChoiceToggle/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Orientation({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Comparison/Content/Orientation"
  
}) {
let imagesComparisonSectionsOrientationValueData = fromData.useDataValue({ viewPath,
context: 'images_comparison_sections',
path: 'orientation',
})
let constantData = 'horizontal'
let aggregateData = fromAggregate.equals(imagesComparisonSectionsOrientationValueData, constantData)
let onClick = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let imagesComparisonSectionsOrientationValueData1 = fromData.useDataValue({ viewPath,
context: 'images_comparison_sections',
path: 'orientation',
})
let constantData1 = 'vertical'
let aggregateData1 = fromAggregate.equals(imagesComparisonSectionsOrientationValueData1, constantData1)
let onClick1 = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Orientation.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<ChoiceToggle
  viewPath={`${viewPath}/ChoiceToggle`}
 text="Horizontal"
 onClick={onClick}
 width={150}
 paddingBottom={4}
 marginLeft={8}
 paddingTop={4}
 data="images_comparison_sections.orientation"
 data="'horizontal'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
/>
<ChoiceToggle
  viewPath={`${viewPath}/ChoiceToggle`}
 text="Vertical"
 onClick={onClick1}
 width={150}
 paddingBottom={4}
 paddingTop={4}
 marginLeft={4}
 data="images_comparison_sections.orientation"
 data="'vertical'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
/>
</div>
{children}
</React.Fragment>)
}